export default __webpack_public_path__ + "static/media/Christopher Pavlopoulos Resume.3fc0cf4e.pdf";